import React, { useEffect, useState } from "react";
import { getCsrfToken } from "../../../../public/api/authApi";
import { GlobalModal } from "../../../../global/GlobalModal";
import { GlobalButton } from "../../../../global/forms/GlobalFormFields";
import { markScheduleCompleted } from "../../api/schedulesApi";
import { ensureCsrfToken } from "../../utils/scheduleHelpers";

export default function CompleteScheduleModal({ schedule, onClose, onSuccess, onError }) {
  const open = Boolean(schedule?.id);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) setLoading(false);
  }, [open, schedule?.id]);

  const handleConfirm = async () => {
    const id = Number(schedule?.id);
    if (!Number.isFinite(id) || id <= 0) return;

    setLoading(true);
    try {
      const csrfToken = await ensureCsrfToken(getCsrfToken);
      const res = await markScheduleCompleted(id, csrfToken);
      onClose?.();
      onSuccess?.(res?.message || "Schedule marked as completed");
    } catch (err) {
      onClose?.();
      onError?.(err?.message || "Failed to mark schedule completed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      title="Mark schedule completed"
      size="sm"
      closeOnBackdrop={!loading}
      footer={
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "flex-end", width: "100%" }}>
          <GlobalButton variant="ghost" onClick={onClose} disabled={loading}>
            Cancel
          </GlobalButton>
          <GlobalButton variant="primary" onClick={handleConfirm} disabled={loading}>
            {loading ? "Saving…" : "Mark completed"}
          </GlobalButton>
        </div>
      }
    >
      <p style={{ fontSize: "0.9375rem", color: "#475569", lineHeight: 1.6 }}>
        Mark <strong>{schedule?.schedule_title}</strong> as completed?
      </p>
    </GlobalModal>
  );
}
